import {
  deleteV1DealerIdBorrowerBorIdIncomeIncId,
  getV1DealerIdBorrowerBorIdIncomes,
  postV1DealerIdBorrowerBorIdIncome,
  putV1DealerIdBorrowerBorIdIncomeIncIdUpdateIncome,
  type DtoCreateIncomeReq,
  type DtoUpdateIncomeReq,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireBorrowerId, type DomainIds } from "./types";

export function createIncomeDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getIncomes: async (borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdIncomes(
        getDealerId(),
        borId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createIncome: async (body: DtoCreateIncomeReq, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdIncome(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },

    updateIncome: async (
      incomeId: string,
      body: DtoUpdateIncomeReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorIdIncomeIncIdUpdateIncome(
        getDealerId(),
        borId,
        incomeId,
        body,
      );
      return assertApiSuccess(response);
    },

    deleteIncome: async (incomeId: string, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await deleteV1DealerIdBorrowerBorIdIncomeIncId(
        getDealerId(),
        borId,
        incomeId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
